import { render, staticRenderFns } from "./BbmAdd.vue?vue&type=template&id=4f781c89&scoped=true"
import script from "./BbmAdd.vue?vue&type=script&lang=js"
export * from "./BbmAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f781c89",
  null
  
)

export default component.exports